import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';

import { LoaderEvent, SetAllMemberCheck } from './../../shared/message.event';
import { PrimecalendarService } from './../primecalendar.service';
import { MemberService } from '../../member/member.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { AppService } from '../../app.service';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UtilityFunctions } from '../../shared/utility-functions';

import * as moment from 'moment';
import * as _ from 'lodash';

@Component({
    selector: 'app-guest-booking',
    templateUrl: './guest-booking.component.html',
    styleUrls: ['./guest-booking.component.css'],
    providers: [
        LoaderEvent, PrimecalendarService, MemberService, AppService, SetAllMemberCheck
    ],
    exportAs: 'bookingPopUpObj'
})
export class GuestBookingComponent implements OnInit {

    @ViewChild('childModal') childModal: ModalDirective;
    @Input() message = '';
    @Input() popupTitle;
    @Output() notify = new EventEmitter<boolean>();
    @Output() notifyDelete = new EventEmitter<boolean>();
    @Output() callBookingAPI = new EventEmitter<any>();
    @Input() deleteMessage;
    @Input() eventData;
    @Input() selectedUnit;
    @Input() category;
    @Input() facilityCloseTime;
    private eventdate;
    private eventStartTime;
    private eventEndTime;
    @Input() facility;
    private bookingObj = {
        emailId: '',
        contactNumber: '',
        membershipId: '',
        userId: '',
        attendees: '',
        hours: ''
    };
    private validate = {
        emailId: '',
        contactNumber: '',
        membershipId: '',
        attendees: '',
        hour: '',
        flag: false
    };
    private isContactDisable = true;
    private memberList = [];
    private isEmailIdDisable = true;
    private popUpMessage = '';
    private vendor;
    private showHour = false;
    private bookingSlot = 0;
    private _appService;
    private utilityFunctions = new UtilityFunctions();
    constructor(private loaderEvent: LoaderEvent, private calendarService: PrimecalendarService,
        private memberService: MemberService, private appService: AppService, private setAllMemberCheck: SetAllMemberCheck) {
        this._appService = appService;
        this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    }

    public showChildModal(membershipId): void {
        this.testCategory();
        this.isEmailIdDisable = true;
        this.bookingObj = {
            emailId: '',
            contactNumber: '',
            membershipId: membershipId ? membershipId : '',
            userId: '',
            attendees: '',
            hours: ''
        };
        this.validate = {
            emailId: '',
            contactNumber: '',
            membershipId: '',
            attendees: '',
            hour: '',
            flag: false
        };
        this.eventdate = this.eventData['startTimeNew'].format('MMM DD YYYY');
        this.eventStartTime = this.eventData['startTimeNew'].format('h A');
        this.eventEndTime = this.eventData['endTimeNew'].format('h A');
        this.childModal.config.backdrop = false;
        this.childModal.show();
    }

    public hideChildModal(): void {
        this.childModal.hide();
    }

    ngOnInit() {
    }

    onClickOk() {
        this.notify.emit(true);
    }

    onClickCancle() {
        this.notify.emit(false);
    }

    settUtcFormat(str) {
        let utcHr: string;
        let currDate = new Date();
        let timeArr = [];
        timeArr = str.split(':');
        currDate.setUTCHours(parseInt(timeArr[0]), parseInt(timeArr[1]));
        let hr = currDate.getHours();
        if (hr < 10) {
            utcHr = '0' + hr;
            return utcHr;
        } else {
            return hr.toString();
        }
    }
    /**
     * Validate mandatory fields
     * 
     * @param {any} validatePara 
     * @param {any} event 
     * @returns 
     * 
     * @memberof GuestBookingComponent
     */
    validatioForMandetoryFields(validatePara, event) {
        try {
            let validateFlag = true;
            if (event && event.keyCode !== 9) {
                switch (validatePara) {
                    case 'membershipId':
                        if (!(this.bookingObj.membershipId + '').trim() || this.bookingObj.membershipId === ' ') {
                            this.bookingObj.membershipId = '';
                            this.validate.membershipId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                            validateFlag = false;
                        } else {
                            this.validate.membershipId = '';
                        }
                        break;
                    case 'emailId':
                        if (!this.utilityFunctions.validateEmail(this.bookingObj.emailId)) {
                            this.validate.emailId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                            validateFlag = false;
                        } else {
                            this.validate.emailId = '';
                        }
                        break;
                    case 'contactNumber':
                        if (!(this.bookingObj.contactNumber + '').trim()) {
                            this.validate.contactNumber = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                            validateFlag = false;
                        } else {
                            this.validate.contactNumber = '';
                        }
                        break;
                    case 'attendees':
                        if (!(this.bookingObj.attendees + '').trim() && ((this.bookingObj.attendees + '').trim().indexOf('+') || (this.bookingObj.attendees + '').trim().indexOf('e'))) {
                            this.validate.attendees = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                            validateFlag = false;
                        } else if (!parseInt(this.bookingObj.attendees)) {
                            this.validate.attendees = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                            validateFlag = false;
                        } else {
                            this.validate.attendees = '';
                        }
                        break;
                    case 'hour':
                        if (this.showHour) {
                            if (!(this.bookingObj.hours + '').trim() && ((this.bookingObj.hours + '').trim().indexOf('+') || (this.bookingObj.hours + '').trim().indexOf('e'))) {
                                this.validate.hour = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                                validateFlag = false;
                            } else if (!parseInt(this.bookingObj.hours)) {
                                this.validate.hour = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                                validateFlag = false;
                            } else {
                                this.validate.hour = '';
                            }
                        }
                        break;
                    case '':
                        validateFlag = this.validateMandetoryFields();
                        break;
                }
            }
            return validateFlag;
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Validate mandatory field
     * 
     * @returns 
     * 
     * @memberof GuestBookingComponent
     */
    validateMandetoryFields() {
        this.validate.flag = true;
        if (!(this.bookingObj.membershipId + '').trim()) {
            this.validate.membershipId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        } else {
            this.validate.membershipId = '';
        }
        if (!this.utilityFunctions.validateEmail(this.bookingObj.emailId)) {
            this.validate.emailId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        } else {
            this.validate.emailId = '';
        }
        if (!(this.bookingObj.contactNumber + '').trim()) {
            this.validate.contactNumber = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        } else {
            this.validate.contactNumber = '';
        }
        if (!(this.bookingObj.attendees + '').trim() && ((this.bookingObj.attendees + '').trim().indexOf('+') || (this.bookingObj.attendees + '').trim().indexOf('e'))) {
            this.validate.attendees = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        } else if (!parseInt(this.bookingObj.attendees)) {
            this.validate.attendees = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
        } else {
            this.validate.attendees = '';
        }
        if (this.showHour) {
            if (!(this.bookingObj.hours + '').trim() && ((this.bookingObj.hours + '').trim().indexOf('+') || (this.bookingObj.hours + '').trim().indexOf('e'))) {
                this.validate.hour = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                this.validate.flag = false;
            } else if (!parseInt(this.bookingObj.hours)) {
                this.validate.hour = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                this.validate.flag = false;
            } else {
                this.validate.hour = '';
            }
        }
        return this.validate.flag;
    }
    /**
     * Reset all fields
     * 
     * 
     * @memberof GuestBookingComponent
     */
    resetAll() {
        this.bookingObj = {
            emailId: '',
            contactNumber: '',
            membershipId: '',
            userId: '',
            attendees: '',
            hours: ''
        };
        this.validate = {
            emailId: '',
            contactNumber: '',
            membershipId: '',
            attendees: '',
            hour: '',
            flag: false
        };
        this.hideChildModal();
    }
    /**
     * Call booking API
     * 
     * @param {any} popUpObj 
     * 
     * @memberof GuestBookingComponent
     */
    bookingRequest(popUpObj) {
        if (this.validateMandetoryFields()) {
            let endTimNew = this.eventData.endTimeNew
            let hours = 0;
            let endTime;
            if (this.showHour) {
                hours = this.eventData.startTimeNew.hours() + parseInt(this.bookingObj.hours);
                endTime = this.eventData.endTimeNew.set({ 'hours': hours, 'second': 0, 'minute': 0, 'millisecond': 0 });
            }
            let requestObject = {
                membershipId: this.bookingObj.membershipId,
                _id: this.bookingObj.userId,
                facilityId: '',
                vendorId: '',
                startTime: this.eventData.startTimeNew.toISOString(),
                endTime: this.showHour ? endTime.toISOString() : endTimNew.toISOString(),
                attendees: this.bookingObj.attendees,
                'hours': this.bookingObj.hours
            };
            this.resetAll();
            this.callBookingAPI.emit(requestObject);
        }
    }
    /**
     * Set contact number as per email id
     * 
     * @param {any} emailId 
     * 
     * @memberof GuestBookingComponent
     */
    setContactNumber(emailId) {
        if (emailId) {
            if (emailId.indexOf(':') > -1) {
                emailId = emailId.split(':')[1].trim();
            }
            this.bookingObj.emailId = emailId;
            let obj = _.find(this.memberList, { emailId: emailId });
            this.bookingObj.contactNumber = obj['contactNumber'];
            this.bookingObj.userId = obj['userId'];

            if (!this.utilityFunctions.validateEmail(this.bookingObj.emailId)) {
                this.validate.emailId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                this.validate.flag = false;
            } else {
                this.validate.emailId = '';
            }
            if (!(this.bookingObj.contactNumber + '').trim()) {
                this.validate.contactNumber = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                this.validate.flag = false;
            } else {
                this.validate.contactNumber = '';
            }
        } else {
            this.validate.emailId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.contactNumber = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.bookingObj.contactNumber = '';
        }

    }
    /**
     * Get member list according to membership id.
     * 
     * @param {any} membershipId 
     * @param {any} popUpObj 
     * 
     * @memberof GuestBookingComponent
     */
    getMemberList(membershipId, popUpObj) {
        if (!(this.bookingObj.membershipId + '').trim()) {
            this.validate.membershipId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            this.validate.flag = false;
            this.bookingObj.emailId = '';
            this.bookingObj.contactNumber = '';
            this.bookingObj.userId = '';
            this.bookingObj.attendees = '';
            this.isEmailIdDisable = true;
        } else {
            this.validate.membershipId = '';
            this.getDataByMemberShipId(membershipId, popUpObj);
        }
    }

    getDataByMemberShipId(membershipId, popUpObj) {
        this.loaderEvent.fire(false);
        let requestObject: any = {
            membershipId: membershipId
        };
        // API call for get member list according to membership id
        if (this._appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
            requestObject.vendorId = this.vendor._id;
        } else {
            requestObject.vendorId = this.vendor.vendorId;
        }

        this.calendarService.getMembersByMembershipId(requestObject).then((result: any) => {
            if (result.status === 'SUCCESS') {
                this.bookingObj.emailId = '';
                this.memberList = result.vendorData[0]['members'];
            } else {
                this.hideChildModal();
                this.memberList = [];
                this.popUpMessage = result.message;
                popUpObj.showChildModal();
            }
            if (this.memberList.length > 0) {
                this.isEmailIdDisable = false;
            } else {
                this.bookingObj.emailId = '';
                this.bookingObj.contactNumber = '';
                this.bookingObj.attendees = '';
                this.isEmailIdDisable = true;
            }
            this.loaderEvent.fire(true);
            return (!this.isEmailIdDisable);
        });
    }

    showParentPopup() {
        this.showChildModal(this.bookingObj.membershipId);
    }

    verificationCode(requestParam, popUpObj) {
        this.loaderEvent.fire(false);
        let requestObject: any = {
            membershipId: requestParam.membershipId
        };
        if (this._appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
            requestObject.vendorId = this.vendor._id;
        } else {
            requestObject.vendorId = this.vendor.vendorId;
        }
        let tempMemberList = [];
        this.calendarService.getMembersByMembershipId(requestObject).then((result: any) => {
            if (result.status === 'SUCCESS') {
                tempMemberList = result.vendorData[0]['members'];
                let obj = _.find(tempMemberList, { emailId: this.bookingObj.emailId });
                if (obj) {
                    this.callBookingAPI.emit(requestParam);
                } else {
                    this.hideChildModal();
                    this.memberList = [];
                    this.popUpMessage = CONSTANT_MESSAGES.DATA_MATCH;
                    popUpObj.showChildModal();
                }
            } else {
                this.hideChildModal();
                this.memberList = [];
                this.popUpMessage = result.message;
                popUpObj.showChildModal();
            }
            if (this.memberList.length > 0) {
                this.isEmailIdDisable = false;
            } else {
                this.bookingObj.emailId = '';
                this.bookingObj.contactNumber = '';
                this.bookingObj.attendees = '';
                this.isEmailIdDisable = true;
            }
            this.loaderEvent.fire(true);
        });
    }

    testCategory() {
        if (_.indexOf(CONSTANT_VALUES.AMENITIES, this.facility.category) >= 0) {
            this.showHour = true;
        } else {
            this.showHour = false;
        }
    }
    /**
     * Validate booking time
     * 
     * @param {any} popUpObj 
     * 
     * @memberof GuestBookingComponent
     */
    bookingTimeValidation(popUpObj) {
        if (this.validateMandetoryFields()) {
            let start = this.eventData.startTimeNew.hours();
            let end = parseInt(this.facilityCloseTime.substring(0, this.facilityCloseTime.length - 9));
            this.bookingSlot = end - start;
            if (this.checkMaxNumberOfPeopleWeekend(popUpObj)) {
                if (this.facility['isAttendeeCountRequired'] &&
                    this.facility['maxNumberOfPeopleWeekday'] &&
                    this.facility['maxNumberOfPeopleWeekday'] < parseInt(this.bookingObj.attendees)) {
                    this.validate.attendees = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                    this.popUpMessage = CONSTANT_MESSAGES.NUMPER_OF_PEOPLE_ERROR;
                    this.hideChildModal();
                    popUpObj.showChildModal();
                } else if (this.showHour && this.bookingSlot < parseInt(this.bookingObj.hours)) {
                    this.popUpMessage = CONSTANT_MESSAGES.DAY_BOOKING_ERROR;
                    this.hideChildModal();
                    popUpObj.showChildModal();
                } else {
                    this.bookingRequest(popUpObj);
                }
            }
        }
    }
    /**
     * Validate maximum number of attendee
     * 
     * @param {any} popUpObj 
     * @returns 
     * 
     * @memberof GuestBookingComponent
     */
    checkMaxNumberOfPeopleWeekend(popUpObj) {
        if (this.facility['isAttendeeCountRequired'] &&
            (this.eventData.startTimeNew.days() === 6 || this.eventData.startTimeNew.days() === 0)) {
            if (this.facility['maxNumberOfPeopleWeekend'] &&
                (this.facility['maxNumberOfPeopleWeekend'] < parseInt(this.bookingObj.attendees))) {
                this.validate.attendees = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                this.popUpMessage = CONSTANT_MESSAGES.NUMPER_OF_PEOPLE_ERROR;
                this.hideChildModal();
                popUpObj.showChildModal();
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    changeEventTime() {
        let hours = 0;
        let endTime;
        if (this.showHour) {
            hours = this.eventData.startTimeNew.hours() + parseInt(this.bookingObj.hours);
            endTime = this.eventData.endTimeNew.set({ 'hours': hours, 'second': 0, 'minute': 0, 'millisecond': 0 });
            this.eventEndTime = endTime.format('h A');
        }
    }
    /**
     * Reset fields
     * 
     * 
     * @memberof GuestBookingComponent
     */
    resetData() {
        this.bookingObj.contactNumber = '';
        this.bookingObj.emailId = '';
        this.memberList = [];
    }
}



// WEBPACK FOOTER //
// ./src/app/primecalendar/guest-booking/guest-booking.component.ts